/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound": "404 - lehte ei leitud",
  "ComingSoon": "Tulevikus",
  "YesanPersonalFinance": "Yesan, Isiklik rahandus",
  "Yesan": "Yesan",
  "PersonalFinance": "Isiklikud rahalised vahendid",
  "YesanDownload": "Yesan alla laadida Yesan",
  "ThisWebsiteUsesCookies": "Kasutame küpsiseid, et koguda ja analüüsida teavet meie saidi toimimise ja kasutamise kohta ning pakkuda sotsiaalmeedia funktsioone. Jätkates nõustute meie",
  "IGotIt": "OK",
  "BecomeFinanciallyFree": "Saage rahaliselt vabaks",
  "inStepsAndActions": "8 sammu ja 3 tegevusega.",
  "TrackPlanAnalyze": "Jälgi. Planeeri. Analüüsi.",
  "FTrack": "1. Jälgi",
  "FPlan": "2. Plan",
  "FAnalyze": "3. Analüüsi",
  "Features": "Omadused",
  "FeaturesSubHeading": "Puhas algaja, juba finantsiliselt kirjaoskamatu, see on rakendus, mida vajate, et saada rahaliselt vabaks.",
  "ManageAccounts": "Kontode haldamine",
  "CashLiquidFixedAssetsLiabilities": "Raha, likviidsus, põhivara ja kohustused.",
  "TrackTransactions": "Jälgi tehinguid",
  "IncomesExpensesTransferInvestments": "Tulud, kulud, ülekanded, investeeringud.",
  "ImportExport": "Import / eksport",
  "YourDataAlwaysAccessible": "Teie andmed alati kättesaadavad.",
  "PlanYourFreedom": "Planeerige oma vabadust",
  "StepsAwayFromFI": "8 sammu kaugusel rahalisest sõltumatusest.",
  "BudgetsAndGoals": "Eelarved ja eesmärgid",
  "CheckYourProgressAndAchieve": "Kontrollige oma edusamme ja saavutage oma finantseesmärgid.",
  "DashboardAndAnalytics": "Armatuurlaud ja analüütika",
  "ReviewLearnOptimizeWith": "Vaadake, õppige, optimeerige diagrammide, ülevaatuste ja tööriistade abil.",
  "Security": "Turvalisus",
  "MilitaryGradeEncryption": "Sõjaline krüpteerimine, biomeetria tugi, teie seadmetes salvestatud andmed.",
  "OfflineMode": "Offline-režiim",
  "YourDataAlwaysAccessibleAndModif": "Teie andmed alati kättesaadavad ja muudetavad.",
  "Track": "Jälgi",
  "Income": "Sissetulek",
  "Expense": "Kulud",
  "Transfer": "Ülekanne",
  "transactionsAndManageAccounts": "tehinguid ja hallata erinevaid kontosid:",
  "checkings": ".",
  "savings": "Säästud",
  "realEstate": "Kinnisvara",
  "stocks": "Aktsiaturud",
  "bonds": "Võlakirjad",
  "crypto": "Krüpto",
  "notes": "Väärtpaberid, sularaha Rahakott",
  "envelopes": "Ümbrikud",
  "privateEquity": "Erakapitali investeerimisfondid",
  "metal": "Metall",
  "retirement": "Pensionile jäämine",
  "lifeInsurance": "Elukindlustus",
  "intellectualProperty": "Intellektuaalne omand",
  "otherLiquidAsset": "Muud likviidsed varad",
  "otherFixedAsset": "Muu põhivara",
  "mortgage": "Hüpoteek",
  "loan": "Tarbimislaen",
  "creditCard": "Krediitkaart",
  "otherLiability": "Muud kohustused",
  "AccountsManagement": "Kontohaldus",
  "MultipleAccountsTypesAndGrouping": "Mitu kontotüüpi ja rühmitamine",
  "LinkAccounts": "Teie asutuste kontode linkimine (saadaval ainult teatud riikides)",
  "SmartAccounts": "Nutikad kontod",
  "AddEditDeleteTransactions": "Tehingute lisamine / muutmine / kustutamine",
  "TickVerifiedTransactions": "Kontrollitud tehingute märkimine",
  "CategorizeTransactions": "Tehingute kategoriseerimine",
  "TagTransactions": "Märgistada tehinguid",
  "TrackKakeiboType": "Jälgi Kakeibo tüüpi",
  "TrackInvestments": "Jälgi investeeringuid (saadaval ainult teatud riikides)",
  "ImportFromCSVFile": "Importida CSV-failist tehinguid täielikult või järk-järgult",
  "ExportToCSVFile": "Eksportida ülekandeid CSV-faili",
  "stepsTowardsFIPlanBudgetingReachGoals": "8 sammu finantsilise sõltumatuse plaani suunas, üksikasjalik eelarve koostamine, saavutage oma finantseesmärgid kiiremini.",
  "levelsTowardsFI": "8 tasandit finantsilise sõltumatuse suunas",
  "EstablishBudgetsPer": "Eelarve koostamine iga",
  "account": "konto",
  "accountType": "kontotüüp",
  "KakeiboType": "Kakeibo tüüp",
  "category": "kategooria",
  "tag": "tag",
  "label": "silt",
  "TrackBudgetsPerFrequency": "Jälgi eelarveid sageduse kaupa",
  "CreateGoalsOnSpendingBalanceCashFlowActions": "Loo eesmärke kulutuste, saldo, rahavoogude, tegevuste kohta",
  "TrackGoalsProgress": "Jälgige eesmärkide edenemist",
  "ReviewLearnOptimizeWithReportsCharts": "Vaadake, õppige, optimeerige aruannete, diagrammide, trendide, ülevaatuste ja tööriistade abil.",
  "Dashboard": "Armatuurlaud",
  "FSNetWorth": "Finantsaruanded: Net Worth",
  "FSPnL": "Finantsaruanded: Kasumiaruanne / kasum ja kahjum",
  "FSBalanceSheetAssetsLiabilities": "Finantsaruanded: Bilanss, varad, kohustused",
  "FSCashFlow": "Finantsaruanded: Rahavoogude aruanne, deebet-krediit, rahavood",
  "FSFlows": "Finantsaruanded: Finantsvood",
  "FSRatios": "Finantsaruanded: Suhtarvud",
  "TrendsMonthEnd": "Kuu lõpu suundumused: Tulud ja kulud, rahavoog",
  "TrendsPerformance": "Tulemuslikkuse suundumused: YoY, MoM, WoW",
  "IncomeTrendsPer": "Tulude suundumused",
  "SpendingTrendsPer": "Kulutuste suundumused",
  "RecurringItemsIE": "Korduvad kirjed: Tulud ja kulud",
  "DebtProgressTrends": "Võlg Progressi suundumused",
  "KakeiboMTDReviewTrends": "Kakeibo: MTD ülevaade, viimane kuu, suundumused",
  "FIWCLE": "Finantssõltumatus: Kulud eluenergia järgi: Seina graafik, kulutused",
  "DebtPaydownSnowballAvalanche": "Võlgade tasumine: Snowball, Avalanche",
  "FullyCustomizableAnalyticsRange": "Täielikult kohandatav analüütika ajaskaala",
  "ContactUs": "Võtke meiega ühendust",
  "Privacy": "Privaatsus",
  "Terms": "Tingimused",
  "About": "Umbes",
  "IAgreeToThe": "Olen nõus",
  "AndThe": "ja",
  "PrivacyPolicy": "Privaatsustingimustega",
  "TermsOfUse": "Kasutustingimused",

  "DigitalSoftwareExperienceTagline": "Digitaalne tarkvarakogemus kaasaegse maailma jaoks",
  "DigitalExperience": "Digitaalne kogemus",
  "SoftwareForTheModernWorld": "Tarkvara kaasaegse maailma jaoks",
  "MobileApplications": "Mobiilirakendused",
  "forConnectedAndOfflineHumans": "ühendatud ja võrguühenduseta inimestele",
  "CloudSaaS": "Pilvepõhine SaaS",
  "ResponsiveAndWebServices": "Responsive ja veebiteenused",
  "PersonalFinanceServices": "Isiklikud finantsteenused",
  "YS_p1": "Yesan on dünaamiline tarkvarafirma, mis on spetsialiseerunud tipptasemel mobiilirakenduste arendamisele, mis on kohandatud tarbijatele. Kuna Yesan tunneb hästi tänapäeva tehnoloogiaga kursis olevate kasutajate arenevaid vajadusi ja eelistusi, on ta pühendunud intuitiivsete, kaasahaaravate ja funktsioonirikaste mobiilikogemuste loomisele, mis rikastavad kasutajate elu.",
  "YS_p2": "Yesani missiooni keskmes on järeleandmatu pühendumine innovatsioonile ja loovusele, iga toode on hoolikalt kujundatud, et pakkuda sujuvat funktsionaalsust ja erakordset kasutajakogemust.",
  "PersonalFinanceApplication": "Isiklik finantsrakendus",
  "YPF_p1": "Yesan, Personal Finance on tipptasemel mobiilirakendus, mis on loodud selleks, et anda kasutajatele kõikehõlmavad finantsjuhtimise vahendid, mis on mugavalt kättesaadavad nende käeulatuses. Yesan, Personal Finance pakub oma elegantse ja intuitiivse kasutajaliidesega terviklikku lähenemist rahaasjade haldamisele, mis on mõeldud igale finantskirjaoskuse tasemele.",
  "YPF_p2": "Peamised funktsioonid hõlmavad eelarve jälgimist, kulude kategoriseerimist ja reaalajas tehingu jälgimist, mis võimaldab kasutajatel vaevata saada ülevaate oma kulutamisharjumustest. Rakendus pakub ka kohandatavaid eelarve koostamise võimalusi, mis võimaldavad kasutajatel seada finantseesmärke ja jälgida oma edusamme aja jooksul.",
  "YPF_p3": "Lisaks sellele seab Yesan, Personal Finance prioriteediks turvalisuse, kasutades kasutajate tundliku finantsteabe kaitsmiseks tipptasemel krüpteerimisprotokolle. Tänu pangatasemel turvameetmetele saavad kasutajad oma kontosid kindlalt siduda ja tehinguid sünkroniseerida, ilma et see ohustaks privaatsust.",
  "YPF_p4": "Yesan, Personal Finance läheb kaugemale kui lihtne eelarve koostamine, pakkudes põhjalikku analüüsi ja personaliseeritud soovitusi finantsotsuste optimeerimiseks. Olgu selleks siis võimalike säästmisvõimaluste tuvastamine, investeerimisportfellide jälgimine või võla tagasimaksmise strateegiate haldamine, rakendus pakub kohandatud teadmisi, mis aitavad kasutajatel saavutada oma finantseesmärke.",
  "Discover": "Avasta",
  "Firstname": "Eesnimi",
  "Lastname": "Perekonnanimi",
  "Company":"Ettevõte",
  "Subject": "Teema",
  "Email": "E-post",
  "Message": "Sõnum",
  "ThankYouForContactingUs": "Täname, et võtsite meiega ühendust",
  "ValidFirstnameRequired": "Vajalik on kehtiv eesnimi.",
  "ValidLastnameRequired": "Vajalik on kehtiv perekonnanimi.",
  "ValidEmailAddressRequired": "Palun sisestage kehtiv e-posti aadress.",
  "ValidSubjectRequired": "Palun valige kehtiv teema.",
  "ValidMessageRequired": "Palun sisestage kehtiv sõnum.",
  "UnableToSendTheFormPleaseRetryLater": "Vormi saatmine ei ole võimalik, palun proovige hiljem uuesti.",
  "Information": "Teave",
  "Sales":"Müük",
  "Support": "Toetus",
  "Press": "Press",
  "Partnership": "Partnerlus",
  "Other": "Muud",
  "Blog":"Blogi",

  "Accept":"Aktsepteeri",
  "Decline":"Tagasi lükata",

  "WorklogCalendar":"Jira tööpäeviku kalender",

  "DirectlyAccessibleInProjectApps":"Projektirakendustes otse kättesaadav",
  "VisualizeWhereYouSpentYourTime":"Visualiseeri, kuhu sa oma aega kulutasid",
  "AllYourWorklogsInACalendar":"Kõik teie tööpäevikud kalendris",
  "MonthSummary":"Kuu kokkuvõte",
  "CheckIfYouForgotToLogTime":"Kontrollige, kas olete unustanud aega logida.",
  "DirectlyAccessTheIssuesAndUpdateTime":"Otsene juurdepääs probleemidele ja aja uuendamine",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"Klõpsake tööpäeviku elemendil, et pääseda otse juurde probleemidele ja muuta oma jälgitud aega",
  "AlsoAvailableInDarkMode":"Saadaval ka tumedas režiimis",
  "DirectlyLogWorkOnTheCalendarVisually":"Otse kalendrisse visuaalselt tööd kirja panna",
  "ClickOnTheCalendarToCreateNewWorklog":"Klõpsake kalendril, et luua uus tööpäevik",

  "AppsForAtlassian":"Rakendused Atlassian jaoks",
  "YCL_p1":"Visualiseeri kõik oma tööpäevikud kalendris kuu-, nädala-, töönädala- ja päevavaatega.",
  "YCL_p2":"Logige tööd otse kalendrist visuaalselt valides ajakava.",
  "YCL_p3":"Tehke kindlaks, kui olete unustanud oma tööajatabelite aja jälgimise.",
  "YCL_p4":"Saadaval teie keeles: inglise (UK), inglise (USA), hiina (lihtsustatud), hiina (traditsiooniline), tšehhi, taani, hollandi, eesti, soome, prantsuse, saksa, ungari, islandi, itaalia, jaapani, korea, norra, poola, portugali (Brasiilia), portugali (Portugal), vene, hispaania, rootsi, türgi.",

  "Kakeibo":"Kakeibo",
  "Genea":"Genea",
  "FinancialPortfolio":"Jira finantsportfell",
  "BringRealFinancialPortfolio":"Tooge Jirasse tõeline finantsportfelli haldus. Jälgige eelarveid, kapitali- ja tegevuskulusid ning projektikulusid ühest kohast.",
  "YFPAboutQ":"Kui palju maksavad meie Jira projektid tegelikult?",
  "YFPAbout":"Jira finantsportfell\nFinantsjuhid ja projektijuhtimise organisatsioonid (PMO) pingutavad, et vastata ühele lihtsale küsimusele:\nKui palju meie Jira projektid tegelikult maksavad?\nJira jälgib tööd.\nFinantsosakond jälgib eelarveid.\nSee rakendus ühendab need kaks lõpuks omavahel.\n\nFinantsportfell muudab Jira kergeks PPM + finantsplaneerimise platvormiks — ilma kallite ettevõtte tööriistadeta.",
  "YFPPorfolioQ":"Portfelli eelarved ja jälgimine",
  "YFPPorfolioP":"Looge portfellid mitme Jira projekti jaoks ja määrake kindlaks: eelarve summa, valuuta, kuupäevavahemik, kaasatud projektid, meeskonnad. Jälgige tegelikke kulusid automaatselt, kui töö Jiras toimub.",
  "YFPPorfolioListQ":"Portfellid",
  "YFPPorfolioListP":"Looge finantsportfellid, mis ühendavad mitut Jira projekti, ja näete kohe: eelarve vs tegelikud kulud, projekti kulutuste määra reaalajas, kapitali- ja tegevuskulude jaotust, kulud ühe probleemi ja projekti kohta, eksporditavaid finantsaruandeid. Kõik toimib otse Jira tööpäevikute põhjal.",
  "CostQ":"Automaatne kulude arvutamine",
  "CostP":"Muutke ajaseire reaalseteks finantsandmeteks. Rakendus: loeb Jira töölogisid, rakendab tunnitasusid, arvutab iga päev projekti tegelikud kulud. Ilma tabelite ja käsitsi tööta.",
  "RatesQ":"Tunnitasud",
  "RatesP":"Määra tunnitasu projekti, meeskonna või üldiselt",
  "ReportQ":"CSV-finantsaruandlus",
  "ReportP":"Ekspordi portfelli finantsandmed sekundites. Ideaalne: rahandusmeeskondadele, finantsjuhi aruandluseks, eelarve planeerimiseks, auditi toetuseks",
  "SettingsQ":"CapEx vs OpEx klassifikatsioon",
  "SettingsP":"Toetab raamatupidamis- ja auditi nõudeid. Klassifitseerib töö järgmiselt: kapitaliseeritav arendus (CapEx), operatiivne töö (OpEx). Genereerib eksporditavaid aruandeid, mis on valmis rahandusmeeskondadele."
};

export const documents = {
};
